import { cloneDefaultSkinTokens } from './defaultSkin';
import { pressedColor } from './runtime';
import type { BubbleRole, EffectiveSkin, SkinManifest, SkinOverrides, SkinTokens } from './types';

const BUBBLE_ROLES: BubbleRole[] = ['user', 'assistant', 'system'];

export function mergeSkinOverrides(tokens: SkinTokens, overrides: SkinOverrides): SkinTokens {
  const next = JSON.parse(JSON.stringify(tokens)) as SkinTokens;
  if (overrides.glassColor !== undefined) next.glass.color = overrides.glassColor;
  if (overrides.panelTransparency !== undefined) next.glass.panelTransparency = overrides.panelTransparency;
  if (overrides.controlTransparency !== undefined) next.glass.controlTransparency = overrides.controlTransparency;
  if (overrides.overlayTransparency !== undefined) next.glass.overlayTransparency = overrides.overlayTransparency;
  if (overrides.glassTintStrength !== undefined) next.glass.tintStrength = overrides.glassTintStrength;
  if (overrides.themeColor !== undefined) {
    next.palette.primary = overrides.themeColor;
    next.palette.primaryPressed = pressedColor(overrides.themeColor);
    next.glass.tintColor = overrides.themeColor;
    if (overrides.iconsFollowTheme === undefined && overrides.iconColor === undefined) {
      next.icons.followTheme = true;
    }
  }
  if (overrides.iconsFollowTheme !== undefined) next.icons.followTheme = overrides.iconsFollowTheme;
  else if (overrides.iconColor !== undefined) next.icons.followTheme = false;
  if (overrides.userBubble !== undefined) next.bubbles.user = overrides.userBubble;
  if (overrides.assistantBubble !== undefined) next.bubbles.assistant = overrides.assistantBubble;
  if (overrides.iconColor !== undefined) next.icons.color = overrides.iconColor;
  if (overrides.wallpaperDataUrl) next.wallpaper.fit = 'cover';
  return next;
}

export function builtinEffectiveSkin(overrides: SkinOverrides = {}): EffectiveSkin {
  return {
    tokens: mergeSkinOverrides(cloneDefaultSkinTokens(), overrides),
    assets: {},
    wallpaperDataUrl: overrides.wallpaperDataUrl ?? null,
    bubbleSources: {},
    label: '内置基础皮肤',
    version: null,
    source: 'builtin',
    offline: true,
  };
}

export function manifestEffectiveSkin(
  manifest: SkinManifest,
  assets: Record<string, string>,
  overrides: SkinOverrides,
  offline: boolean,
): EffectiveSkin {
  const wallpaperAsset = manifest.assets.find((asset) => asset.kind === 'wallpaper');
  const iconSources: Record<string, string> = {};
  const bubbleSources: Partial<Record<BubbleRole, string>> = {};
  for (const asset of manifest.assets) {
    const dataUrl = assets[asset.id];
    if (asset.kind === 'icon' && dataUrl) iconSources[asset.slot] = dataUrl;
    if (asset.kind === 'bubble' && dataUrl && BUBBLE_ROLES.includes(asset.slot as BubbleRole)) {
      bubbleSources[asset.slot as BubbleRole] = dataUrl;
    }
  }
  return {
    tokens: mergeSkinOverrides(manifest.tokens, overrides),
    assets,
    wallpaperDataUrl: overrides.wallpaperDataUrl ?? (wallpaperAsset ? assets[wallpaperAsset.id] ?? null : null),
    iconSources,
    bubbleSources,
    label: manifest.skin.name,
    version: manifest.version.version,
    source: 'official',
    offline,
  };
}

